import { apiFetch } from './api';

/**
 * Relê o `Auth/Me` e troca o `user` do localStorage.
 *
 * Até aqui o `user` só era gravado no login, então uma mudança feita na API
 * (uma funcionalidade desligada em Sistema › Funcionalidades, uma permissão
 * tirada) só aparecia depois de sair e entrar de novo. Agora ele é relido em
 * dois momentos — decisão F2 de docs/designsystem/propostas/admin/fase-6-funcionalidades.html:
 *
 *  - quando a aba volta ao foco, no máximo uma vez a cada 5 minutos;
 *  - quando a API responde 403 `FUNCIONALIDADE_DESLIGADA` (forçado, na hora).
 *
 * Atualização periódica cega foi descartada: gastaria requisição sem ninguém
 * olhando para a tela.
 */
export const USUARIO_ATUALIZADO_EVENT = 'lemeia:usuario-atualizado';

const API_URL = import.meta.env.VITE_API_URL || '';
const INTERVALO_MINIMO_MS = 5 * 60 * 1000;

// Começa "agora": quem acabou de carregar a página acabou de logar ou tem o user recém-lido.
let ultimaLeitura = Date.now();
let leituraEmAndamento: Promise<boolean> | null = null;

/** Devolve `true` se o `user` foi trocado. */
export function relerUsuario(forcar = false): Promise<boolean> {
    if (!localStorage.getItem('user')) return Promise.resolve(false);
    if (!forcar && Date.now() - ultimaLeitura < INTERVALO_MINIMO_MS) return Promise.resolve(false);
    if (leituraEmAndamento) return leituraEmAndamento;

    leituraEmAndamento = (async () => {
        try {
            const res = await apiFetch(`${API_URL}/api/Auth/Me`);
            if (!res.ok) return false;
            const texto = await res.text();
            if (!texto) return false;

            ultimaLeitura = Date.now();
            // Mesmo formato do login (`JSON.stringify` do objeto), senão o escape
            // de acento da API faria toda leitura parecer uma mudança.
            const normalizado = JSON.stringify(JSON.parse(texto));
            if (normalizado === localStorage.getItem('user')) return false;

            localStorage.setItem('user', normalizado);
            window.dispatchEvent(new CustomEvent(USUARIO_ATUALIZADO_EVENT));
            return true;
        } catch {
            return false;
        } finally {
            leituraEmAndamento = null;
        }
    })();

    return leituraEmAndamento;
}
